import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  padding-left: ${props => props.theme.spacing.sp8};
`

export const Actions = styled.div`
  display: flex;
  gap: ${props => props.theme.spacing.sp8};
  align-items: center;
`
